const Triangle = () => (
  <div
    style={{
      position: "absolute",
      marginTop: "28px",
      width: 0,
      height: 0,
      borderLeft: "6px solid transparent",
      borderRight: "6px solid transparent",
      borderBottom: "9px solid #000",
    }}
  >
    <div
      style={{
        position: "relative",
        top: "3.5px",
        left: "-1.9px",
        width: 0,
        height: 0,
        borderLeft: "2px solid transparent",
        borderRight: "2px solid transparent",
        borderBottom: "3px solid #FFF",
      }}
    ></div>
  </div>
);

export default Triangle;
